import { render, staticRenderFns } from "./WorkflowFormSubmissionCalculatedField.vue?vue&type=template&id=c94b35ea&"
import script from "./WorkflowFormSubmissionCalculatedField.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionCalculatedField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports